// WhatsApp Float Component
const WhatsAppFloat = () => {
  return (
    <div className="whatsapp-float">
      <a href="https://wa.me/+919975349144" target="_blank" rel="noopener noreferrer" className="whatsapp-btn">
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
  );
};

export default WhatsAppFloat;